import { render, staticRenderFns } from "./pos-side-bar.vue?vue&type=template&id=c5ec233a&"
import script from "./pos-side-bar.vue?vue&type=script&lang=js&"
export * from "./pos-side-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports